const FieldType = {
    String: 0,
    DateTime: 1,
    Numeric: 2,
    StaticList: 3,
    DynamicList: 4,
    MultiValueList: 5,
    DynamicTableList: 6,
    0: 'string',
    1: 'datetime',
    2: 'numeric',
    3: 'list',
    4: 'dlist',
    5: 'list',
    6: 'dlist',
    string: 0,
    datetime: 1,
    numeric: 2,
    list: 3,
    dlist: 4,
}
export default FieldType
